"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const tslib_1 = require("tslib");
const AggregateRoot_1 = require("../../../core/domain/AggregateRoot");
const Guard_1 = require("../../../core/logic/Guard");
const userCreatedEvent_1 = require("../events/userCreatedEvent");
class User extends AggregateRoot_1.AggregateRoot {
    constructor(props, ref, id) {
        super(props, ref, id);
        this.aggRootCreatedAt = new Date();
    }
    static validate(raw, ref, id) {
        try {
            User_validator_1.default(raw);
            return Guard_1.Guard.pass();
        }
        catch (e) {
            AggregateRoot_1.AggregateRoot.handleValidationError(e, ref, id);
            return Guard_1.Guard.fail(e.message);
        }
    }
    static create(p, ref, id) {
        const user = new User(p, ref, id);
        if (!id) {
            user.addDomainEvent(new userCreatedEvent_1.UserCreatedEvent(user));
        }
        return user;
    }
    get unitIds() {
        return this.value.unitIds;
    }
    get unitIdsArr() {
        return this.value.unitIds ? Object.keys(this.value.unitIds) : [];
    }
    get displayName() {
        return this.name || this.email;
    }
    get name() {
        return `${this.firstName} ${this.lastName}`;
    }
    get email() {
        return this.value.email;
    }
    get firstName() {
        return this.value.firstName || "";
    }
    get lastName() {
        return this.value.lastName || "";
    }
    get street() {
        return this.value.street || "";
    }
    get number() {
        return this.value.number || "";
    }
    get city() {
        return this.value.city || "";
    }
    get zip() {
        return this.value.zip || "";
    }
    get state() {
        return this.value.state || "";
    }
    get country() {
        return this.value.country || "";
    }
    get phone() {
        return this.value.phone || "";
    }
    get contactEmail() {
        return this.value.contactEmail || "";
    }
    get isVerified() {
        return !!this.value.isVerified;
    }
    get isPublic() {
        return !!this.value.isPublic;
    }
    get customData() {
        return this.value.customData || {};
    }
}
exports.User = User;
const User_validator_1 = tslib_1.__importDefault(require("./User.validator"));
//# sourceMappingURL=User.js.map